import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {BackgroundComponent} from "../background/background.component";
import {BorderComponent} from "../border/border.component";
import {ColorComponent} from "../color/color.component";
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';

@Component({
  selector: 'app-input',
  imports: [
    BackgroundComponent,
    BorderComponent,
    ColorComponent
  ],
  templateUrl: './input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './input.component.scss'
})
export class InputComponent extends AbstractStyleComponent {
  @ViewChild('border') borderComponent!: BorderComponent;
  @ViewChild('color') colorComponent!: ColorComponent;
  @ViewChild('background') backgroundComponent!: BackgroundComponent;

  getValue(): any {
    return {
      border: this.borderComponent.getValue(),
      background: this.backgroundComponent.getValue(),
      color: this.colorComponent.getValue(),
    };
  }

  setValue(value: any): void {
    this.borderComponent.setValue(value['border']);
    this.backgroundComponent.setValue(value['background']);
    this.colorComponent.setValue(value['color']);
  }
}
